<template>
  <section class="form">
    <RenderCacheable>
      <Form v-if="formId" :form-id="formId" :prefilled-inputs="inputs" />
    </RenderCacheable>
  </section>
</template>

<script setup lang="ts">
import { type ParagraphFormFragment } from '#graphql-operations'

const route = useRoute()

interface Props {
  data: ParagraphFormFragment
  prefilledInputs?: InputPrefill[]
}

const props = withDefaults(defineProps<Props>(), {
  prefilledInputs: () => {
    return []
  }
})

const inputs = computed(() => {
  const inputs: InputPrefill[] = []
  if (route.query.episode) {
    inputs.push({
      key: 'sendungsausgabe',
      value: route.query.episode.toString()
    })
  }

  return inputs
})

const formId = props.data.form?.first?.id
</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.form {
  @include tools.page-grid-columns;
}
</style>
